/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import data, { Selectors as DataSelectors } from './data';
import actions, { Selectors as ActionsSelectors, sagas as actionSagas } from './actions';
import bar, { sagas as barSagas } from './bar';

export const Selectors = {
  data: DataSelectors,
  actions: ActionsSelectors,
};

export default combineReducers({
  data,
  actions,
  bar,
});

export const sagas = [...actionSagas, ...barSagas];

export { Creators } from './actions';

export type { PiContext } from './context';

export { WatchMode, WatchOptionProvider } from './options/watch';

export type { AppWatchOption } from './options/watch';
